import {
  Banner,
  Button,
  AlertIcon,
  Link,
  Typography,
} from '@iheartjane/reefer';

export interface ErrorScreenProps {
  error: string;
  storeId?: number;
  storeName?: string;
}

export const ErrorScreen = ({
  error,
  storeId,
  storeName,
}: ErrorScreenProps) => {
  return (
    <>
      <Typography variant="h1-semibold">Error</Typography>
      <Banner full mt={12} icon={<AlertIcon />} variant="error" label={error} />
      <Typography mt={12}>
        Please contact{' '}
        <Link
          ariaLabel="link for iheartjane email"
          href={`mailto: support@iheartjane.com`}
        >
          support@iheartjane.com
        </Link>{' '}
        so we can resolve this issue.
      </Typography>
      {storeId && storeName && (
        <Button
          mt={24}
          full
          to={`/stores/${storeId}`}
          label={`Return to ${storeName || 'store'}`}
        />
      )}
    </>
  );
};
